import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  TemplateRef, ViewChild
} from '@angular/core';
import {Location} from '@angular/common';
import {combineLatest, Observable, Subject, takeUntil} from 'rxjs';
import {Chat, Project, RouteInfo, Service} from '@app/shared';
import {ProjectUtilsService} from '../../features/project/services/project-utils.service';
import {NavigationService, ScreenService} from '@app/core';
import {GlobalValuesService} from '../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tr_TR} from 'ng-zorro-antd/i18n';
import {ProjectTabsetComponent} from '../../features/project/components/project-tabset/project-tabset.component';
import {ProjectDetailComponent} from '../../features/project/pages/project-detail/project-detail.component';

@Component({
  selector: 'app-layout-detail',
  standalone: false,

  templateUrl: './layout-detail.component.html',
  styleUrl: './layout-detail.component.less'
})
export class LayoutDetailComponent implements OnDestroy, AfterViewChecked {

  sidebarExpanded = new EventEmitter<void>();

  mainTemplate: TemplateRef<any> | undefined;
  sideTemplate: TemplateRef<any> | undefined;
  @ViewChild(ProjectDetailComponent) projectDetailComponent!: ProjectDetailComponent;
  currentChat: Chat | undefined;
  currentChatName: string | undefined;
  breadcrumb$: Observable<RouteInfo[]>;

  templatesLoaded = false; // bandera para saber si se asignaron los templates

  selectedProject: Project | undefined;
  selectedService: Service | undefined;

  isMobile$;

  showGlobalSearch: boolean = false;
  isCollapsed : boolean = true;

  @Input() showMobileSearchBar: boolean = true;
  @Input() mobileSearchClass: string = 'mobile-search-filter';

  private lastChat: Chat | undefined;
  private lastChatName: string | undefined;
  private updatePending = false;

  destroy$ = new Subject<void>();
  constructor(private location: Location, private ns: NavigationService, private cdRef: ChangeDetectorRef,
              private ps: ProjectUtilsService, private screenService: ScreenService, public gs: GlobalValuesService) {
    this.breadcrumb$ = this.ns.breadcrumb$;
    this.isMobile$ = screenService.isMobile$;

    this.selectedProject = ps.selectedProject;
    this.selectedService = ps.selectedService;
  }

  ngOnInit() {
    // Configurar mobileSearchClass basado en la ruta actual
    this.configureMobileSearchClass();
  }

  private configureMobileSearchClass() {
    // Si la URL contiene '/detail/', es una página de detalles
    if (window.location.href.includes('/detail/')) {
      this.mobileSearchClass = 'mobile-search-filter';
    } else {
      this.mobileSearchClass = 'mobile-search-filter-project';
    }
  }

  ngAfterViewChecked() {
    if (this.updatePending) {
      this.updatePending = false;
      this.cdRef.detectChanges();
    }
  }

  goBack() {
    this.ns.backLevelBreadcrumb();
  }

  // Se invoca cuando se activa una ruta hija; 'componentRef' es la instancia del detail component
  onActivate(componentRef: any): void {
    // Se espera que cada componente de detalle exponga publicamente dos propiedades TemplateRef: mainTemplate y sideTemplate
    if (componentRef.mainTemplate && componentRef.sideTemplate) {
      // Usamos un setTimeout para asegurar que la asignación se realice en el siguiente ciclo para evitar el error
      // ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        this.mainTemplate = componentRef.mainTemplate;
        this.sideTemplate = componentRef.sideTemplate;
        this.getChat();
        this.templatesLoaded = true;

        if (componentRef.dataChanged) {
          componentRef.dataChanged.subscribe(() => {
            this.handleDataChange();
          });
        }
        this.cdRef.detectChanges();
      }, 0);
    }
  }
  handleDataChange() {
    // Forzar la actualización de la vista
    this.updatePending = true;
    this.cdRef.detectChanges();
    if (this.projectDetailComponent) {
    }

  }

  getChat() {
    combineLatest([
      this.ps.currentDetailChat$,
      this.ps.currentChatEntetyName$
    ]).pipe(
      takeUntil(this.destroy$)
    ).subscribe(([chat, entityName]) => {
        // Verificar si realmente hay cambios
        if (chat !== this.currentChat || entityName !== this.currentChatName) {
          this.currentChat = chat;
          this.currentChatName = entityName;

          // Marcar que hay actualizaciones pendientes
          this.updatePending = true;

          // Programar la detección de cambios para el próximo ciclo
          setTimeout(() => {
            if (this.updatePending) {
              this.cdRef.detectChanges();
              this.updatePending = false;
            }
          }, 0);
        }
      });
  }

  toggleGlobalSearch(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.showGlobalSearch = !this.showGlobalSearch;
  }

  toogleSideBar(){
    this.isCollapsed=!this.isCollapsed;
  }
  openChat(){
    this.isCollapsed = false;
    setTimeout(()=>{
      if(!this.isCollapsed){
        this.sidebarExpanded.emit()
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected readonly tr_TR = tr_TR;
}
